import $ from "jquery";

/**
 * Patch voor een formatteringsbug in GP Limit Dates (gp-limit-dates.js).
 *
 * `GPLimitDates.formatDate()` pad wel de maand maar niet de dag (`day =
 * date.getDate()`), waardoor het datumveld bij validatie wordt teruggeschreven als
 * `2026-07-9` in plaats van `2026-07-09`. Dat pad wordt gelopen zodra er geen jQuery
 * UI-datepicker aan het veld hangt — bij ons het geval, omdat Gravity Forms de
 * toegankelijke (WhatSock) datepicker gebruikt.
 *
 * De override houdt de logica van de plugin aan (volgorde + scheidingsteken uit
 * `dateFormat`) en zero-padt zowel maand als dag.
 */

const SEPARATORS = { slash: "/", dot: ".", dash: "-" };

function pad(value) {
    return String(value).padStart(2, "0");
}

function formatDate(date, fieldId, data) {
    const formatBits = data[fieldId].dateFormat.split("_");
    const separator = SEPARATORS[formatBits[1] || "slash"] || "/";

    return formatBits[0]
        .split("")
        .join(separator)
        .replace("m", pad(date.getMonth() + 1))
        .replace("d", pad(date.getDate()))
        .replace("y", date.getFullYear());
}

function patchFormatDate() {
    if (!window.GPLimitDates || window.GPLimitDates.formatDate === formatDate) {
        return;
    }

    window.GPLimitDates.formatDate = formatDate;
}

$(document).on("gform_post_render", patchFormatDate);

$(patchFormatDate);
